// Блок 7: Proof — метрики продукта + founder credibility

const metrics = [
  { value: '50', unit: 'диалогов', label: 'для обучения стиля' },
  { value: '3', unit: 'канала', label: 'в одном inbox' },
  { value: '<\u00A03', unit: 'сек', label: 'на черновик ответа' },
] as const;

export function ProofSection(): JSX.Element {
  return (
    <section className="py-20 lg:py-28 bg-surface-subtle">
      <div className="max-w-6xl mx-auto px-5 sm:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-14 items-center">
          {/* Left — text + quote */}
          <div>
            <h2 className="font-heading text-3xl sm:text-4xl font-extrabold text-text-primary tracking-tight">
              Измеримый результат
            </h2>
            <p className="mt-4 text-text-secondary text-base sm:text-lg leading-relaxed max-w-md">
              Каждое сообщение в Shadow Mode — шаг к автоматизации вашей поддержки.
              Система учится. Первые черновики неидеальны — но с каждым ответом становятся точнее.
            </p>

            {/* Founder quote */}
            <blockquote className="mt-8 pl-4 border-l-2 border-accent-brand">
              <p className="text-text-primary text-sm leading-relaxed italic">
                «Anima не просто бот — это продолжение вашей команды.
                Она перенимает самое ценное: ваш опыт и стиль общения с клиентами.»
              </p>
              <footer className="mt-2 text-xs text-text-muted font-medium">
                — Команда Anima
              </footer>
            </blockquote>
          </div>

          {/* Right — metric cards */}
          <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-1 gap-4">
            {metrics.map((m) => (
              <div
                key={m.label}
                className="flex items-baseline gap-3 p-5 rounded-card bg-white border border-border-subtle"
              >
                <span className="font-heading text-3xl font-extrabold text-accent-brand leading-none">
                  {m.value}
                </span>
                <div>
                  <span className="text-sm font-semibold text-text-primary">{m.unit}</span>
                  <p className="text-xs text-text-muted mt-0.5">{m.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
